export default {
  notification: '',
};
